import React from 'react';
import { IonRouterOutlet } from '@ionic/react';
import { Route } from 'react-router';
import { animationOpacity } from '../../../utils/animation';
import { UserCatalogLocationRedirector } from './UserCatalogLocationRedirector';
import UserBusinessPage from './UserBusinessPage';
import UserProductPage from './UserProductPage';
import UserCatalogPage from './UserCatalogPage';
import UserCatalogLocationResolver from './UserCatalogLocationResolver';

// BUGFIX: Reload the whole app when Ionic router starting to create duplicated pages
// TODO: Remove after change routing to v6 or to next.js
const Once = ({ children }: { children: React.ReactNode }) => {
  const list = document.getElementsByClassName('shouldBeOnce');
  if (list.length > 1) window.location.reload();
  return <div className="shouldBeOnce">{children}</div>;
};

const UserCatalogRoutes: React.FC = () => {
  return (
    <IonRouterOutlet ionPage animation={animationOpacity}>
      <Route exact path="/catalog/:locationName/:companyType/:businessId">
        <UserBusinessPage />
      </Route>

      <Route exact path="/catalog/:locationName/:productId">
        <UserProductPage />
      </Route>

      <Route exact path={'/catalog/:locationName'}>
        <Once>
          <UserCatalogLocationResolver>
            <UserCatalogPage />
          </UserCatalogLocationResolver>
        </Once>
      </Route>

      <Route exact path={'/catalog'}>
        <UserCatalogLocationRedirector />
      </Route>
    </IonRouterOutlet>
  );
};

export default UserCatalogRoutes;
